import { format } from "date-fns";

export const formatDate = (value) => {
  const date = new Date(value);

  return format(date, "dd-MM-yyyy, EEEE");
};
